module.exports = __webpack_public_path__ + "static/pointing-10d288c9d0a58214d135e9e6aaf0dec5.jpg";